import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import DreamlandPage from './pages/DreamlandPage';
import MiranshPage from './pages/MiranshPage';
import ShreeLilaPage from './pages/ShreeLilaPage';
import HotelLoader from './pages/HotelLoader';

function AppRoutes() {
  const [loadingHotel, setLoadingHotel] = useState(null);
  const navigate = useNavigate();

  const handleHotelSelect = (hotel) => {
    setLoadingHotel(hotel);
  };

  const handleLoaderDone = (hotelId) => {
    navigate(`/hotel/${hotelId}`);         // ✅ navigate FIRST
    setTimeout(() => {
      setLoadingHotel(null);               // ✅ hide loader AFTER navigation
    }, 100);
  };

  return (
    <>
      <HotelLoader
        hotel={loadingHotel}
        visible={!!loadingHotel}
        onDone={handleLoaderDone}
      />
      <Routes>
        <Route path="/" element={<LandingPage onHotelSelect={handleHotelSelect} />} />
        <Route path="/hotel/dreamland-inn" element={<DreamlandPage />} />
        <Route path="/hotel/miransh-heavenly" element={<MiranshPage />} />
        <Route path="/hotel/shree-lila" element={<ShreeLilaPage />} />
        <Route path="*" element={<LandingPage onHotelSelect={handleHotelSelect} />} />
        
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </div>
  );
}

export default App;